export const isFocusMovingToPopover = (
  relatedTarget: EventTarget | null,
  popoverSelector: string
): boolean =>
  relatedTarget instanceof HTMLElement &&
  Boolean(relatedTarget.closest(popoverSelector));
